import React, { useEffect, useState } from 'react';
import { TextFieldProps } from '@mui/material/TextField';
import Input from './styles/Input';

interface CustomTextFieldProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value: string | number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  decimalPlaces?: number;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

function RoundedNumberField({ value, onChange, decimalPlaces = 2, onBlur, ...props }: CustomTextFieldProps) {
  const formatValue = (val: string | number): string => {
    const num = parseFloat(String(val));
    if (Number.isNaN(num)) return String(val);

    return Number.isInteger(num) ? String(num) : num.toFixed(decimalPlaces);
  };

  const [localValue, setLocalValue] = useState<string | number>(formatValue(value));

  useEffect(() => {
    setLocalValue(formatValue(value));
  }, [value, decimalPlaces]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalValue(e.target.value);
  };

  const handleClick = () => setLocalValue(String(value));

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setLocalValue(formatValue(e.target.value));
    onChange(e);
    onBlur?.(e);
  };

  return (
    <Input
      {...props}
      type="number"
      value={localValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onClick={handleClick}
    />
  );
}

export default RoundedNumberField;
